<template>
    <div>
        <form @submit.prevent="submit">
            <div class="form-row mb-3 align-items-center">
                <div class="form-group col-lg-3">
                    <label for="model">{{ $t('omsz-form.labels.model') }}</label>
                    <multiselect
                        id="model"
                        v-model="model"
                        track-by="value"
                        label="name"
                        :placeholder="$t('omsz-form.placeholders.select')"
                        :selectLabel="$t('omsz-form.placeholders.select_enter')"
                        :selectedLabel="$t('omsz-form.placeholders.selected')"
                        :deselect-label="$t('omsz-form.placeholders.remove')"
                        :options="models"
                        :allow-empty="false"
                        :searchable="false"
                        :disabled="isDisabled"
                        :class="{'is-invalid': !isValid.elementValid}"
                        @select="selectModel">
                        <template slot="noResult">{{ $t('omsz-form.errors.not_found') }}</template>
                    </multiselect>
                </div>
								<div class="form-group col-lg-3">
                    <label for="element">{{ $t('omsz-form.labels.pollen') }}</label>
                    <multiselect
                        id="element"
                        v-model="element"
                        track-by="value"
                        label="name"
                        :placeholder="$t('omsz-form.placeholders.select')"
                        :selectLabel="$t('omsz-form.placeholders.select_enter')"
                        :selectedLabel="$t('omsz-form.placeholders.selected')"
                        :deselect-label="$t('omsz-form.placeholders.remove')"
                        :options="elements"
                        :allow-empty="false"
                        :searchable="false"
                        :disabled="isDisabled"
                        :class="{'is-invalid': !isValid.elementValid}"
                        @select="selectElement">
                        <template slot="noResult">{{ $t('omsz-form.errors.not_found') }}</template>
                    </multiselect>
                </div>
								
                <div class="col-lg-3 buttons mt-2">
                    <button id="send" class="btn btn-primary" type="submit" :disabled="!element || isLoading">
                        <span>{{ $t('omsz.buttons.start_query') }}</span>
                        <i class="icon icon-arrow-right"></i>
                    </button>
                </div>
            </div>
        </form>

        <span v-show="isLoading">{{ $t('omsz.placeholders.please_wait') }}</span>
        <div v-if="errorMessage">{{ errorMessage }}</div>
         <air-pollution v-if="airPollutionData" :air-pollution-data="airPollutionData"/>
        <div v-if="response && !errorMessage" class="vue-img-container"></div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import AirPollution from '../airPollutionPages/AirPollution';

export default {
    name: 'cams',
    components: {
        Multiselect,
        AirPollution,
    },
    
    props: {
        elements: {
            type: Array,
        },
        models: {
            type: Array,
        },
        defaultmodel: {
            type: Object,
            default: '',
        },
				defaultelement: {
            type: Object,
            default: '',
        },
    },
    data() {
        return {
            element: null,
						model: null,
            form: {
                    element: null,
										model: null,
                },
            isValid: {
                elementValid: true,
								modelValid: true,
            },
            isLoading: false,
            isDisabled: false,
            errorMessage: '',
            response: null,
            airPollutionData: null,
        }
    },
    created() {
        //console.log(this.defaultmodel.value);
        //console.log(this.defaultelement.name);
        this.element = this.elements;
        this.model = this.models;
        if(this.defaultelement) {
            this.element = this.defaultelement;
            this.form.element = this.defaultelement.value;
        }
				if(this.defaultmodel) {
            this.model = this.defaultmodel;
            this.form.model = this.defaultmodel.value;
        }

        if (this.defaultelement.value !== '') {
            this.element = this.elements.find(option => option.value === this.defaultelement.value);
        }
				if (this.defaultmodel.value !== '') {
            this.model = this.models.find(option => option.value === this.defaultmodel.value);
        }

        this.submit();


    },
    methods: {
        selectElement(e) {
            this.isValid.elementValid = true;
            this.form.element =  e.value;
        },
        selectModel(e) {
            this.isValid.modelValid = true;
            this.form.model =  e.value;
        },
        async submit(e) {
						const modelValue =  this.model.value
            const elementValue = this.element.value

            if(!modelValue) {
                this.isValid.modelValid = false
            }
            if(!elementValue) {
                this.isValid.elementValid = false
            }
						
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;
            this.errorMessage = null;
            this.airPollutionData = null;

						if(this.isValid.modelValid && this.isValid.elementValid) {

						  axios.post('/api/modelling/cams', {
									model: this.model.value,
									element: this.element.value,
							}).then(({ data }) => {
									this.airPollutionData = Object.assign(data, { element: this.element });
							}).catch(error => {
									this.errorMessage = this.$t('omsz-form.errors.no_result');
							}).finally(() => {
									this.isLoading = false;
							});
							
						}
												
                //const form = this.form

                //try{
                //    const data = await axios.post("/api/modelling/cams", form, {
                //        headers: { 'Accept-Language': window.Met.locale }
                //    })

                //    this.response = data.imageUrls
                //}
                //catch (error) {
                //    this.errorMessage = this.$t('omsz-form.errors.not_response')
                //}
                //finally {
                //    this.isLoading = false
                //}
           //}
           // axios.post('/api/modelling/cams', {
           //     //area: this.area.value,
           //     element: this.element.value,
           // }).then(({ data }) => {
           //     this.airPollutionData = Object.assign(data, { element: this.element });
           // }).catch(error => {
           //     this.errorMessage = this.$t('omsz-form.errors.no_result');
           // }).finally(() => {
            //    this.isLoading = false;
            //});
           // }
				}
    }
}

</script>